import React from 'react';
import Icon from '@pushpay/icon';

const SandboxSettingsIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.37 2H3.63C2.73 2 2 2.73 2 3.632V20.37c.002.9.73 1.63 1.63 1.63h16.74c.9 0 1.628-.73 1.63-1.63V3.632C22 2.73 21.27 2 20.37 2zm-.453 18.333l-15.834.035a.417.417 0 01-.416-.417L3.632 4.083c0-.23.186-.416.416-.416l15.869-.034c.23 0 .416.186.416.416v15.868c0 .23-.186.416-.416.416zM5.75 16.583h5.538a2.917 2.917 0 005.59 0h1.372a.834.834 0 000-1.666h-1.372a2.917 2.917 0 00-5.59 0H5.75a.834.834 0 000 1.666zm8.333-2.083a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM5.75 9.083h.955a2.917 2.917 0 005.59 0h5.955a.834.834 0 000-1.666h-5.955a2.917 2.917 0 00-5.59 0H5.75a.834.834 0 000 1.666zM9.5 7a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default SandboxSettingsIcon;